import { SimData, SimDataKeys, SimDTO } from 'src/common/components/Sim/constants/sim';

export type RSimStatusLabel = 'Active';

export enum RsimProfileStatus {
  Unknown,
  PrimaryProfileActive,
  SecondaryProfileActive,
  PrimaryProfileDisconnected,
  SecondaryProfileDisconnected,
  UnknownDisconnected,
}

export type RSimConfiguration = {
  euicc: string;
  appliedOtaConfigurationProfile: string;
  appliedOtaConfigurationVersion: string;
  isPendingConfiguration: boolean;
  isCustomConfigurationDetected: boolean;
};

export type RSimInventoryResponsePagination = {
  totalCount: number;
  totalPages: number;
};

export type SimProfilesResponseDataHeader = {
  id: string;
  types: SimDataKeys[];
};

export type RSimSimProfilesResponseData = {
  items: SimData[];
  headers?: SimProfilesResponseDataHeader[];
};

export type SimProfilesDTO = {
  headers: SimProfilesResponseDataHeader[];
  items: SimDTO[];
  totalCount: number;
  totalPages: number;
};
